import React, { useEffect } from 'react';
import { isAndroidCapacitor } from '../../utils/platformUtils';
import './MobileGridAd.css';

/** Cap mobile in-feed height — never allow AdSense auto to grow into a tall square. */
export const MOBILE_GRID_AD_HEIGHT_PX = 100;

/**
 * Fixed-height AdSense for phone/tablet web browse grids (full-width row).
 * Hidden on Capacitor (AdMob) and at the desktop grid breakpoint.
 */
export default function MobileGridAd({ slot }) {
    const isNative = isAndroidCapacitor?.() === true;

    useEffect(() => {
        if (isNative || !slot) return;

        try {
            if (typeof window !== 'undefined') {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            }
        } catch (e) {
            console.error('AdSense mobile grid push error:', e);
        }
    }, [isNative, slot]);

    if (isNative || !slot) return null;

    return (
        <div className="msv-mobile-grid-ad" aria-label="Advertisement">
            <div className="msv-mobile-grid-ad-inner">
                <ins
                    className="adsbygoogle"
                    style={{
                        display: 'block',
                        width: '100%',
                        height: `${MOBILE_GRID_AD_HEIGHT_PX}px`,
                        maxHeight: `${MOBILE_GRID_AD_HEIGHT_PX}px`,
                        overflow: 'hidden',
                    }}
                    data-ad-client="ca-pub-1511890644353474"
                    data-ad-slot={slot}
                    data-ad-format="horizontal"
                />
            </div>
        </div>
    );
}
